import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"d-flex flex-column justify-center align-center ma-4"},[_c('div',[_vm._v("ERROR")]),_vm._v(" "),_c('div',{staticClass:"text-h1"},[_vm._v(_vm._s(_vm.error.statusCode))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c(VBtn,{attrs:{"text":"","color":"var(--bg)","to":"/","exact":""}},[_vm._v("Back to main page")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }